import React from 'react';

import RelativeUploadedTime from 'components/RelativeUploadedTime';
import {
  useChartDataUpdatedAt,
  useChartIsFetching,
} from 'scenes/DashboardPage/data';

const RelativeUploadedTimeDashboard = () => {
  const isChartFetching = useChartIsFetching();
  const chartDataUpdatedAt = useChartDataUpdatedAt();
  if (isChartFetching) {
    return null;
  }
  return <RelativeUploadedTime dataUpdatedAt={chartDataUpdatedAt} />;
};
export default RelativeUploadedTimeDashboard;
